import React, { useEffect, useState, useRef } from 'react';
import '../../../Styles/Reels/ReelsIndex.css';
import VideoCard from '../../../Components/VideoCard';
import SideMenuBar from '../../../Components/Layouts/SideMenuBar';
import TopMenuBar from '../../../Components/Layouts/TopMenuBar';
import RightSideBar from '../../../Components/Layouts/RightSideBar';
import { useCart } from '../../../CartProvider';
import { useParams } from 'react-router-dom';
import axiosUserInstance from '../../../axiosUserInstance';
import { HashLoader } from 'react-spinners';

function Reels() {
    const {coordinate} = useCart();
    const [postData, setPostData] = useState([]);
    const [restaurant, setRestaurant] = useState([]);
    const [hasMoreData, setHasMoreData] = useState(true); 
    const [hasFetchedOnce, setHasFetchedOnce] = useState(false);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const videoRefs = useRef([]);
    const {reelsId} = useParams();
    const [activeUnmutedId, setActiveUnmutedId] = useState(null);
    
    const handleVideoRef = (ref, index) => {
        if (ref) {
            videoRefs.current[index] = ref;
        }
    };

    const handleGlobalMuteChange = () => {};

    const parseAvatarKey = (key) => {
        if (!key) return [];

        try {
            const parsed = JSON.parse(key.replace(/\\/g, ''));

            if (Array.isArray(parsed)) {
                return parsed;
            }

            if (typeof parsed === 'string') {
                return [parsed];
            }

            return [];
        } catch (error) {
            if (typeof key === 'string' && key.startsWith('http')) {
                return [key];
            }
            return [];
        }
    };

    const getPosts = async () => {
        try {
            setLoading(true);
    
            let apiURL;
            if (reelsId) {
                apiURL = `/posts/sharepost/${reelsId}/0,0`;
            } else {
                apiURL = `/posts/location?pageNo=${page}&pageSize=10&location=${coordinate?.lat},${coordinate?.lng}`;
            }
            const response = await axiosUserInstance.get(apiURL);
            setHasFetchedOnce(true);
    
            const postInformation = response?.data?.posts[0]?.Post_Information || [];
    
            if (reelsId) {
                setPostData(postInformation);
                setRestaurant(postInformation);
            } else {
                if (postInformation.length > 0) {
                    setPostData((prevData) => (page === 1 ? [...postInformation] : [...prevData, ...postInformation]));
                    setRestaurant((prevData) => (page === 1 ? [...postInformation] : [...prevData, ...postInformation]));
                } else {
                    setHasMoreData(false);
                }
            }
        } catch (error) {
            console.error('Error fetching posts:', error);
        } finally {
            setLoading(false);
        }
    };
    
    const handleInfiniteScroll = async () => {
        try {
            if (
                window.innerHeight + document.documentElement.scrollTop + 1 >=
                document.documentElement.scrollHeight
            ) {
                if (hasMoreData) {
                    setPage((prev) => prev + 1);
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getPosts(); 
    }, [page, coordinate?.lat, coordinate?.lng, reelsId]);

    useEffect(() => {
        window.addEventListener('scroll', handleInfiniteScroll);
        return () => window.removeEventListener('scroll', handleInfiniteScroll);
    }, [hasMoreData]);


    useEffect(() => {
        if (!postData.length) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const video = entry.target;
                    if (entry.isIntersecting && video.readyState >= 3) {
                        video.play().catch((error) => console.error('Video play error:', error));
                    } else {
                        video.pause();
                    }
                });
            },
            { threshold: 0.75 }
        );

        videoRefs.current.forEach((videoRef) => {
            if (videoRef && videoRef.src) {
                observer.observe(videoRef);
            } else {
                console.warn('Video source is missing', videoRef);
            }
        });
        
        return () => observer.disconnect();
    }, [postData]);

    return (
        <>
            <div className="reels-dashboard">
                <div className="topmenubar">
                    <SideMenuBar getPosts={getPosts}></SideMenuBar>
                    <div className="top-bar-mobile">
                        <TopMenuBar backIconVisible = {false}/>
                    </div>
                </div>

                <div className="main-container">
                    <div className="video-container main-container-reels">
                        {postData.length === 0 &&  !loading && hasFetchedOnce &&
                                <div className="no-posts-message" 
                                    style={{ textAlign: 'center', marginTop: '100px', fontSize: '25px', color: '#888'}}>
                               No Posts Found
                                </div>
                        }
                        {postData?.map((post, index) => (
                            (post?.Attachment_keys || [])?.map((attachment) => {
                                const avatarUrls = parseAvatarKey(attachment?.Avatar_key || '[]');
                                return avatarUrls?.map((url) => (                                 
                                    <VideoCard
                                        key={post?.Post_ID}
                                        id={post?.Post_ID}
                                        vendorID={post?.Post_Vendor_id}
                                        AccountID={post?.User_Info?.User_ID}
                                        url={url}
                                        attachmentKeys={post?.Attachment_keys || []}
                                        profilePic={post?.User_Info?.Profile_Picture || ''}
                                        firstName = {post?.User_Info?.First_Name || ''}
                                        lastName = {post?.User_Info?.Last_Name || ''}
                                        userName={post?.User_Info?.Username || ''}
                                        restaurantName={post?.Vendor_Info?.[0]?.Vendor_Name || ''}
                                        starPic={post?.Restaurant_Info?.[0]?.Star_Image || ''}
                                        rating={post?.Vendor_Info?.[0]?.Vendor_Avg_Rating || 0}
                                        distance={post?.Vendor_Info?.[0]?.Vendor_Distance || 0}
                                        description={post?.Post_Description}
                                        likes={post?.Post_Likes_count}
                                        shares={post?.Post_Shares_count}
                                        comments={post?.Post_Comments_count}
                                        setLike={() => {}}
                                        activeUnmutedId={activeUnmutedId}
                                        setActiveUnmutedId={setActiveUnmutedId}
                                        index={index}
                                        setVideoRef={(ref) => handleVideoRef(ref, index)}
                                        handleGlobalMuteChange={() => handleGlobalMuteChange(index)}
                                        autoplay={index === 0}
                                        restaurant={restaurant}
                                        coordinate={coordinate}
                                        likeFlag={post?.LikedFlag}
                                        saveFlag={post?.SavedFlag}
                                        reelsId={post?.Post_ID}
                                        itemName={post?.Menu_items_Info?.[0]?.Menu_item_Name || ''}
                                        vendorDescription={post?.Vendor_Info?.[0]?.Vendor_Description || ''}
                                        vendorAddress={
                                            `${post?.Vendor_Info?.[0]?.Vendor_Address || ''}, ${post?.Vendor_Info?.[0]?.Vendor_City || ''}, ${post?.Vendor_Info?.[0]?.Vendor_State || ''}, ${post?.Vendor_Info?.[0]?.Vendor_PostalCode || ''}, ${post?.Vendor_Info?.[0]?.Vendor_Country || ''}`
                                        }
                                        followFlag={post?.FollowFlag}
                                        filter={post?.Post_filter || ''}
                                        user_Rating_count={post?.Vendor_Info?.[0]?.Vendor_Review_User_Count}
                                    />
                                ));
                            })
                        ))}
                        {loading && <div style={{ textAlign: 'center', padding: '20px', display: 'flex', justifyContent: 'center'}}>
                            <HashLoader
                                color="#E13535"
                                loading={true}
                                size={50}
                            />
                        </div>}
                    </div>
                </div>

                <RightSideBar/>

            </div>
        </>
    );
}

export default Reels;

